module.exports = __webpack_public_path__ + "img/qrcode.d923ef72.png";